<template>
    <Form :label-width="80">
        <Form-item label="真实姓名" prop="name">
            <Input type="text" v-model="formCustom.name"></Input>
        </Form-item>
        <Form-item label="账户名" prop="username">
            <Input type="text" v-model="formCustom.username"></Input>
        </Form-item>
        <Form-item label="手机号" prop="phone">
            <Input type="text" v-model="formCustom.phone"></Input>
        </Form-item>
        <Form-item label="创建时间" prop="username">
            <Input type="text" v-model="formCustom.cdate"></Input>
        </Form-item>
        <Form-item label="管理员" prop="type">
            <Select v-model="formCustom.type" placeholder="请选择">
                <Option :value="0">高级管理员</Option>
                <Option :value="1">中级管理员</Option>
                <Option :value="2">初级管理员</Option>
            </Select>
        </Form-item>
        <Form-item label="区域" prop="area">
            <Select v-model="formCustom.area" placeholder="请选择">
                <Option :value="1">业务东区</Option>
                <Option :value="2">业务南区</Option>
                <Option :value="3">业务西区</Option>
                <Option :value="4">业务北区</Option>
            </Select>
        </Form-item>
    </Form>
</template>
<script>
    import { mapState } from 'vuex'
    export default{
        data(){
            return {
                formCustom:{
                    name:null,
                    phone:null,
                    username:null,
                },
            }
        },
        created(){
            this.getData();
            this.$store.dispatch('parent2ShowFn');
        },
        methods:{
            getData(){
                var _this=this;
                _this.$http.get('/web/admin/getAdminDetail',{
                    params:{aid:_this.$route.query.aid}
                }).then(function(res){
                    _this.formCustom=res.data;
                    _this.formCustom.area=eval(res.data.area);
                    _this.$Message.success('加载成功');
                }).catch(function(res){
                });
            },
        }
    }
</script>
<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/rights/seeRight.vue